module.exports = __webpack_public_path__ + "static/media/7.32afb12c.png";